export const style = {
  image: {
    position: `relative`,
    top: `50%`,
    marginTop: `-3px`,
    marginLeft: `4px`,
    marginRight: `4px`,
    maxHeight: `16px`,
    maxWidth: `16px`
  },
  table: {
    borderColor: `#eee`
  },
  th: {
    fontSize: `14px`,
    fontWeight: 600,
    textTransform: `uppercase`,
    padding: `20px 12px`,
    borderColor: `#eee`
  },
  thCenter: {
    textAlign: `center`
  },
  tr: {
    fontSize: `14px`
  },
  td: {},
  tdNameSpan: {
    // textTransform: `uppercase`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Rates/style/table.js